var event = {
    /**
     * @param {*} name 监听的事件名
     * @param {*} fn 事件的回调方法
     */
    on: function (name, fn, sourceUrl) {
        !this.map[name] && (this.map[name] = []);
        this.map[name].push(fn);
        if (sourceUrl) {
            !this.urls[decodeURIComponent(sourceUrl)] && (this.urls[decodeURIComponent(sourceUrl)] = []);
            this.urls[decodeURIComponent(sourceUrl)] && this.urls[decodeURIComponent(sourceUrl)].push(name);
        }
    },
    /**
     * @param {*} name 取消监听的事件名
     * @param {*} fn 取肖监听的事件方法，省略此参数，表示取消所有为name的事件监听
     */
    off: function (name, fn, url) {
        if (!fn) {
            return delete this.map[name];
        }
        var list = this.map[name] || [];
        for (var i = 0; i < list.length; i++) {
            if (list[i] === fn) {
                list.splice(i, 1);
                break;
            }
        }
        // 当前页面下有绑定的事件时，清除其下所有的事件
        if (url && this.urls[decodeURIComponent(url)]) {
            this.urls[decodeURIComponent(url)].forEach(evtName => {
                delete this.map[evtName];
            });
            delete this.urls[decodeURIComponent(url)];
        }
        !list.length && delete this.map[name];
    },
    /**
     * @param {*} name 发送{name}事件
     * @param {*} entry 发送事件并带上数据{entry}，此参数可省略
     * @param {*} once once=true，表示发送{name}事件，之后立即取消监听{name}事件
     */
    emit: function (name, entry, once) {
        var list = this.map[name];
        list &&
            list.map(fn => {
                fn(entry);
            });
        if (once) {
            delete this.map[name];
        }
    },
    map: {},
    urls: {},
};

if (!window.__event__) {
    window.__event__ = event;
}
export default window.__event__;
